/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelWirecode.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/wirecode";

export class AutogenModelWirecode<RowType extends ModelRow> extends Endpoint<RowType, RowWirecodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowWirecode extends ModelRow<RowWirecodeFields> {
	constructor(values?: Partial<RowWirecodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowWirecodeFields {
	"fuel_interface.company_id": string;
	"fuel_interface.currency": string;
	"fuel_interface.descr": string;
	"fuel_interface.id": string;
	"ifuel_control.assignee_type": string;
	"ifuel_control.atm_access": string;
	"ifuel_control.auto_inquiry": string;
	"ifuel_control.bin_number": string;
	"ifuel_control.business_individual": string;
	"ifuel_control.card_ip_address": string;
	"ifuel_control.card_ip_url": string;
	"ifuel_control.card_maint_port": string;
	"ifuel_control.card_type": string;
	"ifuel_control.cash_ip_address": string;
	"ifuel_control.cash_port": string;
	"ifuel_control.category_update": Date;
	"ifuel_control.communication_type": string;
	"ifuel_control.company_id": string;
	"ifuel_control.contract_update": Date;
	"ifuel_control.disp_equip_status": string;
	"ifuel_control.email_1": string;
	"ifuel_control.email_2": string;
	"ifuel_control.email_3": string;
	"ifuel_control.email_4": string;
	"ifuel_control.enable_misc_product": string;
	"ifuel_control.expiration_date": string;
	"ifuel_control.fuel_account_id": string;
	"ifuel_control.fuel_interface_id": string;
	"ifuel_control.fuel_subaccount_id": string;
	"ifuel_control.has_atm_cash": string;
	"ifuel_control.iday_create_callin": string;
	"ifuel_control.iday_create_trans": string;
	"ifuel_control.iday_last_end": Date;
	"ifuel_control.iday_last_start": Date;
	"ifuel_control.ifuel_login": string;
	"ifuel_control.ifuel_password": string;
	"ifuel_control.include_errors": string;
	"ifuel_control.info_prompt": string;
	"ifuel_control.ip_address": string;
	"ifuel_control.is_active": string;
	"ifuel_control.last_emp_no": string;
	"ifuel_control.log_level": number;
	"ifuel_control.notify_users": string;
	"ifuel_control.order_setting": string;
	"ifuel_control.order_validate": string;
	"ifuel_control.payroll_settlement": string;
	"ifuel_control.pin_setting": string;
	"ifuel_control.pin_validate": string;
	"ifuel_control.plus_less_flag": string;
	"ifuel_control.po_setting": string;
	"ifuel_control.po_validate": string;
	"ifuel_control.port": string;
	"ifuel_control.preserve_vndr_drid": string;
	"ifuel_control.security_card_no": string;
	"ifuel_control.service_authorization": string;
	"ifuel_control.tax_id_type": string;
	"ifuel_control.tch_contract1": number;
	"ifuel_control.tch_contract10": number;
	"ifuel_control.tch_contract2": number;
	"ifuel_control.tch_contract3": number;
	"ifuel_control.tch_contract4": number;
	"ifuel_control.tch_contract5": number;
	"ifuel_control.tch_contract6": number;
	"ifuel_control.tch_contract7": number;
	"ifuel_control.tch_contract8": number;
	"ifuel_control.tch_contract9": number;
	"ifuel_control.tch_contract_url": string;
	"ifuel_control.tchws_client_id": string;
	"ifuel_control.tchws_last_login": Date;
	"ifuel_control.tractor_hub_setting": string;
	"ifuel_control.tractor_hub_validate": string;
	"ifuel_control.tractor_setting": string;
	"ifuel_control.tractor_validate": string;
	"ifuel_control.trans_ip_address": string;
	"ifuel_control.transaction_port": string;
	"ifuel_control.trusted_cert_url": string;
	"ifuel_control.update_asset_status": string;
	"ifuel_control.update_card_status": string;
	"ifuel_control.update_disp_status": string;
	"ifuel_control.update_drvr_callin": string;
	"ifuel_control.update_drvr_status": string;
	"ifuel_control.update_equip_id": string;
	"ifuel_control.update_order_id": string;
	"ifuel_control.validation_type": string;
	"ifuel_control.vru_access": string;
	"wirecode.allow_aft_xfer_settlement": string;
	"wirecode.ap_glid": string;
	"wirecode.carrier_limit_amount": number;
	"wirecode.carrier_limit_amount_c": string;
	"wirecode.carrier_limit_amount_d": Date;
	"wirecode.carrier_limit_amount_n": number;
	"wirecode.carrier_limit_amount_r": number;
	"wirecode.carrier_limit_method": string;
	"wirecode.carrier_order_pct_limit": number;
	"wirecode.carrier_valid_move_status": string;
	"wirecode.charge_code_id": string;
	"wirecode.company_id": string;
	"wirecode.company_limit_amount": number;
	"wirecode.company_limit_amount_c": string;
	"wirecode.company_limit_amount_d": Date;
	"wirecode.company_limit_amount_n": number;
	"wirecode.company_limit_amount_r": number;
	"wirecode.company_limit_method": string;
	"wirecode.company_order_pct_limit": number;
	"wirecode.company_valid_move_status": string;
	"wirecode.contract_carrier": number;
	"wirecode.contract_driver": number;
	"wirecode.contract_no_payee": number;
	"wirecode.contract_ownerop": number;
	"wirecode.create_deduction": string;
	"wirecode.create_other_charge": string;
	"wirecode.deduct_code_id": string;
	"wirecode.deduct_in_provider_currency": string;
	"wirecode.deduct_status": string;
	"wirecode.descr": string;
	"wirecode.driver_fee_amt": number;
	"wirecode.driver_fee_amt_c": string;
	"wirecode.driver_fee_amt_d": Date;
	"wirecode.driver_fee_amt_n": number;
	"wirecode.driver_fee_amt_r": number;
	"wirecode.expense_glid": string;
	"wirecode.fuel_interface_id": string;
	"wirecode.id": string;
	"wirecode.include_fee_exp": string;
	"wirecode.is_active": string;
	"wirecode.is_atm_cash": string;
	"wirecode.issuing_user_group": string;
	"wirecode.issuing_users": string;
	"wirecode.msts_addl_fee_percent": number;
	"wirecode.msts_addl_fee_threshold": number;
	"wirecode.msts_addl_fee_threshold_c": string;
	"wirecode.msts_addl_fee_threshold_d": Date;
	"wirecode.msts_addl_fee_threshold_n": number;
	"wirecode.msts_addl_fee_threshold_r": number;
	"wirecode.no_validation": string;
	"wirecode.ownerop_limit_amount": number;
	"wirecode.ownerop_limit_amount_c": string;
	"wirecode.ownerop_limit_amount_d": Date;
	"wirecode.ownerop_limit_amount_n": number;
	"wirecode.ownerop_limit_amount_r": number;
	"wirecode.ownerop_limit_method": string;
	"wirecode.ownerop_order_pct_limit": number;
	"wirecode.ownerop_valid_move_status": string;
	"wirecode.plus_minus": string;
	"wirecode.require_order": string;
	"wirecode.service_charge": number;
	"wirecode.service_charge_c": string;
	"wirecode.service_charge_d": Date;
	"wirecode.service_charge_n": number;
	"wirecode.service_charge_r": number;
	"wirecode.subaccount_carrier": string;
	"wirecode.subaccount_driver": string;
	"wirecode.subaccount_no_payee": string;
	"wirecode.subaccount_ownerop": string;
	"wirecode.unposted_wire_status": string;
	"wirecode.wire_type": string;
}

